import { render, staticRenderFns } from "./osdImgViewer.vue?vue&type=template&id=0bb8ff54"
import script from "./osdImgViewer.vue?vue&type=script&lang=js"
export * from "./osdImgViewer.vue?vue&type=script&lang=js"
import style0 from "./osdImgViewer.vue?vue&type=style&index=0&id=0bb8ff54&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports